import { Box } from '@pets-ui/Box/Box'
import { HStack } from '@pets-ui/HStack/HStack'
import { type LinearProgressProps } from '@pets-ui/LinearProgress/LinearProgress'
import { LinearProgress } from '@pets-ui/LinearProgress/LinearProgress'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'

interface RegularGiveawayProgressBarProps {
  total?: number
  current?: number
  value?: LinearProgressProps['value']
  width?: number
  displayText?: boolean
}

const styles = stylex.create({
  progressHeight: {
    height: '6px',
  },
})

export const RegularGiveawayProgressBar = (props: RegularGiveawayProgressBarProps) => {
  const { value = 0, width } = props
  return (
    <HStack gap={3} alignItems="center" width={width}>
      <Box flexGrow="1" backgroundColor={colors.grey100} borderRadius={4} height={6} position="relative">
        <LinearProgress color={colors.yellow600} variant="determinate" value={value} rootStyle={styles.progressHeight} />
        {/* 基礎長度 20px */}
        <Box backgroundColor={colors.yellow600} borderRadius={4} height={6} width={20} position="absolute" left={0} top={0} />
      </Box>
    </HStack>
  )
}
